<inka-back (back)="back()" [color]="backButtonLightColor ? '#ffffff' : '#111111'">
</inka-back>
<h3 class="header-title" *ngIf="header">
  {{ header | translate}}
</h3>
<inka-time class="header-time" *ngIf="!header && !hideTimer"></inka-time>
<span class="header-options">
  <ng-content></ng-content>
</span>